export default {
  products: [],
  courseList: []
}
